import { FC } from 'react';
import { ServerSelect, ServerSelectProps } from '@shared/components';
import { USER_SEARCH_MIN_LENGTH, useUserSelectSearch } from '../hooks';

export type UserSelectProps = Omit<ServerSelectProps, 'onSearch' | 'options' | 'loading' | 'isSearchable' | 'minSearchLength'> & {
  /** Əlavə server filtrləri, məs. `{ admin: 1 }` — əməkdaşlar, `{ admin: 3 }` — kuryerlər. */
  query?: Record<string, any>;
  enabled?: boolean;
  /** Server filtri siyahını kiçik saxlayırsa açın — siyahı yazmadan da görünür. */
  preload?: boolean;
};

/**
 * İstifadəçi seçimi: siyahını brauzerə yükləmir, `/api/admin/v2/users/select` üzərindən
 * serverdə axtarır. Seçilmiş dəyərin adı siyahıda olmasa belə ayrıca yüklənir.
 */
export const UserSelect: FC<UserSelectProps> = ({ value, query, enabled, preload, ...rest }) => {
  const users = useUserSelectSearch({ selected: value, query, enabled, preload });

  return (
    <ServerSelect
      value={value}
      onSearch={users.setSearch}
      options={users.options}
      loading={users.isLoading}
      isSearchable={users.isSearchable || users.hasOptionsWithoutSearch}
      minSearchLength={USER_SEARCH_MIN_LENGTH}
      hintText={`Ad, soyad və ya ID üzrə ən azı ${USER_SEARCH_MIN_LENGTH} simvol daxil edin`}
      emptyText="İstifadəçi tapılmadı"
      placeholder="Ad, soyad və ya ID ilə axtarın..."
      {...rest}
    />
  );
};

export type UserSelectFilterProps = Omit<UserSelectProps, 'value' | 'onChange'> & {
  column: { filterValue?: any; setFilter: (value: any) => void };
};

/** `next-table` sütun filtri üçün adapter — `Filter:` xanasına birbaşa verilir. */
export const UserSelectFilter: FC<UserSelectFilterProps> = ({ column: { filterValue, setFilter }, ...rest }) => (
  <UserSelect value={filterValue ?? undefined} onChange={(value) => setFilter(value ?? undefined)} {...rest} />
);
